<div class="p-2">
    <adaa-data-table
        #adaaDataTable
        [apiName]="'getFAQS'"
        [titleHeader]="'breadcrumbs.faqs.list' | translate"
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.HELP_FAQS"
        [enableViewAction]="false"
        (actionClicked)="getAction($event)"
        (addNewClicked)="addNew()"
    ></adaa-data-table>
</div>
